import { fetchWithCache, getCachedData } from "../services/apiService";

export const featureRetrieve = async (feature_list, { setFeatures }) => {
  const cacheKey = `/api/property/featureRetrieve_${JSON.stringify(feature_list)}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setFeatures(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/property/featureRetrieve",
      {
        method: "POST",
        body: JSON.stringify({ feature_list }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    setFeatures(Array.isArray(data) ? data : []);
  } catch (error) {
    if (!cached) {
      setFeatures([]);
    }
  }
};
